export const staticOrders = [
  {
    id: 10000001,
    status: 'lead',
    customer: 'Oliver Hawthorne',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 Pro': { price: '1650', quantity: '25', setupCosts: '150' },
      'Antminer S19j Pro': { price: '1850', quantity: '15', setupCosts: '75' },
      'Antminer S19x Pro': { price: '1650', quantity: '25', setupCosts: '150' }
    },
    total: 18765.65
  },
  {
    id: 10000002,
    status: 'lead',
    customer: 'Nathaniel Frost',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19j Pro': { price: '1650', quantity: '25', setupCosts: '150' }
    },
    total: 14016.87
  },
  {
    id: 20000001,
    status: 'new',
    customer: 'Sarah Lee',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 Hydro': { price: '1900', quantity: '15', setupCosts: '200' }
    },
    total: 20754.65
  },
  {
    id: 20000002,
    status: 'new',
    customer: 'John Doe',
    address: {
      street: 'Oak Lane 8',
      city: 'Chicago',
      zipCode: '60601',
      country: 'United States'
    },
    order: {
      'Antminer S21': { price: '2100', quantity: '10', setupCosts: '100' }
    },
    total: 26421.87
  },
  {
    id: 20000003,
    status: 'new',
    customer: 'Emma Brown',
    address: {
      street: 'Sunset Boulevard 123',
      city: 'Los Angeles',
      zipCode: '90001',
      country: 'United States'
    },
    order: {
      'Antminer S19j Pro': { price: '1850', quantity: '20', setupCosts: '150' }
    },
    total: 35042.18
  },
  {
    id: 30000001,
    status: 'paid',
    customer: 'Oliver Hawthorne',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 Pro': { price: '1650', quantity: '12', setupCosts: '150' }
    },
    total: 18765.65
  },
  {
    id: 30000002,
    status: 'paid',
    customer: 'Nathaniel Frost',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19j Pro': { price: '1650', quantity: '8', setupCosts: '150' }
    },
    total: 14016.87
  },
  {
    id: 40000001,
    status: 'placed',
    customer: 'Lucas Chang',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S21': { price: '2100', quantity: '20', setupCosts: '100' }
    },
    total: 52843.74
  },
  {
    id: 50000001,
    status: 'shipped',
    customer: 'John Doe',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 XP Hydro': {
        price: '2500',
        quantity: '30',
        setupCosts: '300'
      }
    },
    total: 66843.75
  },
  {
    id: 50000002,
    status: 'shipped',
    customer: 'Lucas Chang',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S21': { price: '2100', quantity: '20', setupCosts: '100' }
    },
    total: 52843.74
  },
  {
    id: 50000003,
    status: 'shipped',
    customer: 'Nathaniel Frost',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19j Pro': { price: '1650', quantity: '8', setupCosts: '150' }
    },
    total: 24863.21
  },
  {
    id: 60000001,
    status: 'deployment',
    customer: 'Lucas Chang',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S21': { price: '2100', quantity: '20', setupCosts: '100' }
    },
    total: 52843.74
  },
  {
    id: 70000001,
    status: 'active',
    customer: 'John Doe',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 XP Hydro': {
        price: '2500',
        quantity: '30',
        setupCosts: '300'
      }
    },
    total: 75960.65
  },
  {
    id: 70000002,
    status: 'active',
    customer: 'Jane Smith',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S21 Pro': { price: '3000', quantity: '45', setupCosts: '500' }
    },
    total: 118898.42
  },
  {
    id: 70000003,
    status: 'active',
    customer: 'Michael Johnson',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S19 Pro Hydro': {
        price: '2200',
        quantity: '15',
        setupCosts: '200'
      }
    },
    total: 60768.52
  },
  {
    id: 80000001,
    status: 'canceled',
    customer: 'Lucas Chang',
    address: {
      street: 'Highstreet 1',
      city: 'Mustertown',
      zipCode: '34568',
      country: 'Germany'
    },
    order: {
      'Antminer S21': { price: '2100', quantity: '20', setupCosts: '100' }
    },
    total: 52843.74
  }
];
